/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';

const getUserInfo = (formData) => axios.post(`${SDLUtil.API_URL}/noauth/login/id`, formData);
const getNewEpTrayUserInfo = formData => axios.post(`${SDLUtil.API_URL}/noauth/login/new-eptray`, formData);

const setHeaderToken = token => {
  axios.defaults.headers.common['x-auth-token'] = token;
};

export default {
  async login(userId, password) {
    try {
      const formData = new FormData();
      formData.append('userId', userId);
      formData.append('password', password);
      const userInfoResponse = await getUserInfo(formData);
      this.setToken(userInfoResponse.data.jwtToken);

      return Object.assign(userInfoResponse.data, { code: 'authOk' });
    } catch (err) {
      return err.data.error;
    }
  },
  async loginNewEpTray(userInfo, key) {
    try {
      const formData = new FormData();
      formData.append('encodeUserInfo', userInfo);
      formData.append('encodeAesKey', key);
      const userInfoResponse = await getNewEpTrayUserInfo(formData);
      this.setToken(userInfoResponse.data.jwtToken);

      return Object.assign(userInfoResponse.data, { code: 'authOk' });
    } catch (err) {
      // console.error('login:', err);
      return err.data.error;
    }
  },
  logout() {
    this.setToken('');
  },
  setToken(token) {
    if (token === '' || token === null) {
      // impersonator check
      if (localStorage.getItem('adminToken') !== null && localStorage.getItem('adminToken') !== '') {
        // call axios
        axios.put(`${SDLUtil.API_URL}/impersonation/logout`).then(() => {});
        this.setToken(localStorage.getItem('adminToken'));
        localStorage.setItem('adminToken', '');
        axios.defaults.headers.common['original-user-id'] = '';
        document.location = `${SDLUtil.WEB_CONTEXT_PATH}/`;
      } else {
        setHeaderToken('');
        localStorage.setItem('user', '');
        localStorage.setItem('userToken', '');
      }
    } else {
      setHeaderToken(token);
      localStorage.setItem('userToken', `${token}`);
      localStorage.setItem('user', JSON.stringify(SDLUtil.parseJwt(token)));

      console.log('setToken language');
      console.log(SDLUtil.DEFAULT_LANG);
      console.log(window.navigator.language);
      console.log(window.navigator.userLanguage);
      console.log(SDLUtil.getLoginedUserInfo().language);
      const defaultLang = (SDLUtil.DEFAULT_LANG || window.navigator.language || window.navigator.userLanguage).replace('-', '_');
      SDLUtil.setI18nLanguage(defaultLang || SDLUtil.getLoginedUserInfo().language); // Change to language setting of login user
    }
  },
};



// WEBPACK FOOTER //
// ./src/service/loginService.js